import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://api.recursooficial.com.br',
  // baseURL: 'http://localhost:3333',
});
